module.exports = __webpack_public_path__ + "images/emoji/dvd.73d43b648a2a23b5b31d.png";